import { formatNumberWithDotAndComma } from '@/utils/moneyFormatter';
import { ColumnDef } from '@tanstack/react-table';

export const columns: ColumnDef<Collector>[] = [
  {
    accessorKey: 'id',
    header: () => <div className='text-left'>Order id</div>,
    cell: ({ row }) => {
      return <div className='text-left  '>{row.getValue('id')} </div>;
    },
  },
  {
    accessorKey: 'Customer.commercial_name',
    header: 'Customer',
  },

  {
    accessorKey: 'amount',
    header: () => <div className='text-left'>Amount</div>,
    cell: ({ row }) => {
      const value: number = row.getValue('amount');
      const amount = formatNumberWithDotAndComma(value.toString());
      return (
        <div className='text-left font-semibold'>
          {amount} <span className='text-sm font-normal'>DZD</span>{' '}
        </div>
      );
    },
  },
  // {
  //     accessorKey: 'lastPayment',
  //     header: () => <div className='text-left'>Last Payment</div>,
  //     cell: ({ row }) => {
  //         const amount = row.getValue('balance')
  //             ? parseFloat(row.getValue('balance'))
  //             : 0;
  //         const formatted = new Intl.NumberFormat('en-US', {
  //             style: 'currency',
  //             currency: 'DZD',
  //         }).format(amount);

  //         return <div className='text-left '>{formatted}</div>;
  //     },
  // },
  {
    accessorKey: 'date',
    header: () => <div className='text-left'>Date</div>,
    cell: ({ row }) => {
      const date = row.getValue('date')
        ? new Date(row.getValue('date'))
        : new Date();
      const formatted = new Intl.DateTimeFormat('en-US', {
        dateStyle: 'medium',
      }).format(date);

      return <div className='text-left '>{formatted}</div>;
    },
  },
  {
    accessorKey: 'wilaya',
    header: 'Wilaya',
    // header: ({ column }) => {
    //   return (
    //     <Button
    //       variant='ghost'
    //       className='p-0'
    //       onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
    //     >
    //       wilaya
    //       <ArrowUpDown className='w-4 h-4 ml-2' />
    //     </Button>
    //   );
    // },
  },
];
